import { shallowTracer } from "@app-services/shallow-tracer.service";
import { ConfigSync } from "@classes/config-sync.class";
import { SsoLastModalShown } from "@classes/sso-last-modal-shown.class";
import { Config } from "@configs/config";
import { IStorageService } from "@interfaces/storage-service.interface";

export class RoamingStorageService implements IStorageService {

    public get<Type>(key: string): Type {
        return Office?.context?.roamingSettings?.get(key);
    }

    public set<Type>(key: string, value: Type) {
        Office?.context?.roamingSettings?.set(key, value);
    }

    public remove(key: string): void {
        Office?.context?.roamingSettings?.remove(key);
    }

    public commit(): Promise<string | null> {
        return new Promise((resolve, reject) => {
            Office?.context?.roamingSettings?.saveAsync(res => {

                if (res.status !== Office.AsyncResultStatus.Succeeded) {
                    shallowTracer.error("Error while committing roaming storage");
                    return reject(res?.error?.message);
                }

                return resolve(null);
            });
        });
    }

    public getConfigSync(): ConfigSync {

        return Office?.context?.roamingSettings?.get(Config.storageKeys.configSync);
    }

    public setConfigSync(configSync: ConfigSync): void {

        configSync.lastSyncDate = new Date();
        Office?.context?.roamingSettings?.set(Config.storageKeys.configSync, configSync);
    }

    public isConfigSame(oldConfigSync: ConfigSync, newConfigSync: ConfigSync): boolean {

        return oldConfigSync?.finishedDataIngestion === newConfigSync?.finishedDataIngestion
            && oldConfigSync?.activeTenant === newConfigSync?.activeTenant
            && oldConfigSync?.applicationId === newConfigSync?.applicationId
            && oldConfigSync?.tenantId === newConfigSync?.tenantId
            && oldConfigSync?.ignoreClicked === oldConfigSync?.ignoreClicked;
    }

    public getSsoLastModalShown(): SsoLastModalShown[] {

        return Office?.context?.roamingSettings?.get(Config.storageKeys.ssoLoginModalLastShown) ?? [];
    }

    public setSsoLastModalShown(ssoLastLoginModalShown: SsoLastModalShown[]): void {

        Office?.context?.roamingSettings?.set(Config.storageKeys.ssoLoginModalLastShown, ssoLastLoginModalShown);
    }
}